import { useState } from "react";
import { Send, Loader2 } from "lucide-react";

const fmtTime = (iso) => {
  try { return new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return ""; }
};

export default function MaintenanceThread({ messages = [], side, onSend, busy, quickReplies = [], placeholder }) {
  const [text, setText] = useState("");
  const send = async () => {
    const t = text.trim();
    if (!t) return;
    await onSend(t);
    setText("");
  };
  return (
    <div data-testid="maint-thread">
      <div className="space-y-2 max-h-64 overflow-y-auto pr-1 mb-3">
        {messages.length === 0 && <p className="text-sm text-slate-400">No messages yet. Start the conversation below.</p>}
        {messages.map((m) => {
          const mine = m.sender === side;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${mine ? "bg-blue-700 text-white rounded-br-sm" : "bg-slate-100 text-slate-800 rounded-bl-sm"}`}>
                <p className={`text-[10px] mb-0.5 ${mine ? "text-blue-100" : "text-slate-400"}`}>{m.sender_name || (m.sender === "staff" ? "Property team" : "Tenant")} · {fmtTime(m.at)}</p>
                <p className="whitespace-pre-wrap leading-snug">{m.text}</p>
              </div>
            </div>
          );
        })}
      </div>
      {quickReplies.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {quickReplies.map((q, i) => (
            <button key={i} type="button" data-testid={`quick-reply-${i}`} onClick={() => setText((t) => (t ? t + " " : "") + q)}
              className="text-xs border border-slate-300 text-slate-600 hover:bg-slate-50 rounded-full px-2.5 py-1 transition-colors">{q}</button>
          ))}
        </div>
      )}
      <div className="flex items-end gap-2">
        <textarea data-testid="maint-thread-input" value={text} onChange={(e) => setText(e.target.value)} rows={2}
          placeholder={placeholder || "Type your message…"}
          className="flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 resize-none" />
        <button type="button" data-testid="maint-thread-send" onClick={send} disabled={busy || !text.trim()}
          className="bg-blue-700 text-white hover:bg-blue-800 rounded-lg px-3 py-2.5 font-medium flex items-center gap-1.5 disabled:opacity-50 shrink-0 transition-colors">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />}
        </button>
      </div>
    </div>
  );
}
